<nb-card>
  <nb-card-header>Auszug erfassen</nb-card-header>
  <nb-card-body>
    <p class="dialog-message">
      Bitte wählen Sie das Auszugsdatum für <strong>{{ customerNumber }}</strong>.
    </p>
    <div class="dialog-form-field">
      <label class="label">Auszugsdatum *</label>
      <wr-date-picker [(ngModel)]="endDate"></wr-date-picker>
    </div>
    @if (error) {
      <nb-alert status="danger" closable (close)="error = null" style="margin-top: 1rem;">
        {{ error }}
      </nb-alert>
    }
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="basic" (click)="cancel()">Abbrechen</button>
    <button nbButton status="warning" (click)="submit()">Auszug bestätigen</button>
  </nb-card-footer>
</nb-card>
